var ko = require('knockout'),
  MEMBERSHIPTYPE = require('_js/constants/membership-type'),
  ACCESSLEVEL = require('_js/constants/article-access-level');

function Model(params) {
  var self = this;
  self.article = params.result || params.article;
  self.isLocked = ko.observable(false);

  if (
    (self.article.AccessLevel !== ACCESSLEVEL.ALL && window.username === '') ||
    (window.username !== '' &&
      self.article.AccessLevel === ACCESSLEVEL.MEMBERS &&
      window.membershipType === MEMBERSHIPTYPE.NONMEMBER)
  ) {
    self.isLocked(true);
  }
}

Model.prototype.init = function(element) {
  this.$element = $(element);
};

Model.prototype.truncate = function() {
  $(this.$element.find('.truncate-later')).dotdotdot({
    ellipsis: '... ',
    wrap: 'word',
    fallbackToLetter: true,
    watch: true
  });
};

module.exports = Model;
